import React from 'react';
import { Box, BoxProps, Grid, styled } from '@beeline.com/bp-design-system';

interface ModalBodyProps extends Omit<BoxProps, 'ref'> {
  children?: React.ReactNode;
  constrainBox?: boolean;
  stretch?: boolean;
}

export const ModalBody = ({ children, stretch, constrainBox, ...boxProps }: ModalBodyProps) => {
  return (
    <StyledBox
      component="div"
      className="modal-body"
      overflow={!stretch ? 'auto' : undefined}
      $constrainBox={constrainBox}
      {...boxProps}
    >
      <Grid
        flexGrow={2}
        height="100%"
        maxWidth="100%"
        container
        direction="column"
        display={!stretch ? 'block' : undefined}
      >
        {children}
      </Grid>
    </StyledBox>
  );
};

const StyledBox = styled(Box)<{ $constrainBox?: boolean }>`
  ${({ $constrainBox }) => $constrainBox && 'max-width: calc(100% - 25px)'}; // For 24px padding on the left with +1 for border.
`;
